module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('nav', {
    staticClass: "navbar is-light is-fixed-top"
  }, [_c('div', {
    staticClass: "bd-special-shadow"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "static/kithara.svg",
      "alt": "Kithara",
      "width": "112",
      "height": "28"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "navbar-burger burger",
    class: {
      'is-active': _vm.navbarShown
    },
    on: {
      "click": function($event) {
        return _vm.toggleNavbar()
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu",
    class: {
      'is-active': _vm.navbarShown
    }
  }, [_c('div', {
    staticClass: "navbar-start"
  }, [_c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'home'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNavbar(false)
      }
    }
  }, [_vm._v("\n            Home\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'table'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNavbar(false)
      }
    }
  }, [_vm._v("\n            Table\n          ")]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-item",
    attrs: {
      "to": {
        name: 'playlists'
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNavbar(false)
      }
    }
  }, [_vm._v("\n            Playlists\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "navbar-end"
  }, [_c('div', {
    staticClass: "navbar-item"
  }, [_c('div', {
    staticClass: "field is-grouped is-grouped-multiline"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        return _vm.download()
      }
    }
  }, [_c('span', [_vm._v("Export")])]), _vm._v(" "), _c('a', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('span', [_vm._v("Logout")])])])])])])])])]), _vm._v(" "), _c('router-view', {
    staticClass: "router-view",
    nativeOn: {
      "click": function($event) {
        return _vm.toggleNavbar(false)
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ad685f72!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 324
// module chunks = 2